import React, { useEffect, useState } from 'react';
import ProviderCard from './ProviderCard';
import { fetchProviders } from '../api/client';

export default function FeaturedProviders() {
  const [featured, setFeatured] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let active = true;
    fetchProviders({ limit: 6 })
      .then((data) => {
        if (!active) return;
        setFeatured(data.providers.filter((p) => p.featured));
        setStatus('ready');
      })
      .catch(() => active && setStatus('error'));
    return () => {
      active = false;
    };
  }, []);

  return (
    <section className="section">
      <div className="section-header">
        <h2>Proveedores destacados</h2>
        <p>Conoce a algunos de los proveedores mejor calificados por otras familias.</p>
      </div>
      {status === 'error' && (
        <p className="empty-state">No pudimos cargar los proveedores destacados. Intenta más tarde.</p>
      )}
      <div className="provider-grid">
        {featured.map((p) => (
          <ProviderCard provider={p} key={p.id} />
        ))}
      </div>
    </section>
  );
}
